import { useEffect, useState } from 'react'
import PwEyeIcon from '@nv/images/design/pw-eye-icon'
import PwEyeSlashIcon from '@nv/images/design/pw-eye-slash-icon'
import clsx from 'clsx'
import { getIn } from 'formik'
import { useTranslation } from 'react-i18next'
import { FormikError } from '../formik_error/FormikError'
import { NVButton } from '../nv_button/NVButton'
import styles from './TextField.module.scss'

export const TextField = ({
  formik,
  field,
  placeholder,
  label,
  value,
  onChange,
  disabled = false,
  type = 'text',
  isRequired = false,
  isPassword = false,
  classes = {},
  min,
  max,
  autoComplete = 'off',
  ariaLabel,
  describedBy,
  maxChars,
}: any) => {
  const [passwordVisible, setPasswordVisible] = useState(false)
  const currentValue = formik ? (getIn(formik.values, field) ?? '') : (value ?? '')
  const [charCount, setCharCount] = useState(currentValue.length)
  const { t } = useTranslation()

  useEffect(() => {
    setCharCount(currentValue.length)
  }, [currentValue])

  const handleChange = (e) => {
    const newValue = e.target.value
    if (!maxChars || newValue.length <= maxChars) {
      setCharCount(newValue.length)
      if (formik && field) formik.setFieldValue(field, newValue)
      onChange?.(e)
    }
  }

  return (
    <div className={clsx(styles['container'], classes.container, isPassword && styles['password'])}>
      {label && (
        <label htmlFor={field} className={styles['label']}>
          {label}
          {isRequired && (
            <span className={styles['asterisk']} aria-hidden='true'>
              *
            </span>
          )}
        </label>
      )}

      <div className={styles['input__container']}>
        <input
          {...formik.getFieldProps(field)}
          id={field}
          type={isPassword && passwordVisible ? 'text' : isPassword ? 'password' : type}
          placeholder={placeholder}
          className={styles['input']}
          disabled={disabled}
          required={isRequired}
          min={type === 'number' ? min : undefined}
          max={type === 'number' ? max : undefined}
          autoComplete={autoComplete}
          aria-label={ariaLabel}
          aria-disabled={disabled ? 'true' : 'false'}
          aria-describedby={
            [describedBy, formik?.submitCount > 0 && formik?.errors[field] ? `${field}-error` : null].filter(Boolean).join(' ') || undefined
          }
          aria-invalid={formik?.submitCount > 0 && formik?.errors[field] ? 'true' : 'false'}
          value={currentValue}
          onChange={handleChange}
          onBlur={() => formik?.setFieldTouched?.(field, true)}
        />

        {isPassword && (
          <NVButton
            variant='iconOnly'
            onClick={() => setPasswordVisible(!passwordVisible)}
            ariaLabel={passwordVisible ? t('main.hidePassword') : t('main.showPassword')}
            icon={!passwordVisible ? <PwEyeIcon /> : <PwEyeSlashIcon />}
            classes={{ container: styles['icon'] }}
          />
        )}
      </div>

      {maxChars && (
        <div className={styles['max-chars']}>
          {charCount}/{maxChars}
        </div>
      )}

      {formik && <FormikError formik={formik} fieldName={field} />}
    </div>
  )
}
